import { render, staticRenderFns } from "./RiskHeatmap.vue?vue&type=template&id=13d68da9"
import script from "./RiskHeatmap.vue?vue&type=script&lang=js"
export * from "./RiskHeatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports